import React from 'react'
import { Route } from 'react-router-dom'
import Dashboard from './Dashboard'
import Layout from './Layout'

// prettier-ignore
export default (
  <Route>
    <Route element={<React.Suspense><Layout /></React.Suspense>}>
      {Dashboard}
    </Route>
  </Route>
)
